import { render, staticRenderFns } from "./PersonCreateOrAssociate.vue?vue&type=template&id=35c7260a"
import script from "./PersonCreateOrAssociate.vue?vue&type=script&lang=js"
export * from "./PersonCreateOrAssociate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports